import { useContext } from "react"
import { Helmet, HelmetProvider } from "react-helmet-async"
import MainContext from "../common/MainContext"
import { AdminRole } from "../common/constants"
import HeaderFooterLayout from "../components/layouts/HeaderFooterLayout"
import MarketingReports from "./MarketingReports"
import CompanyDashboard from "./dashboard/CompanyDashboard"
import EventPartnerDashboard from "./dashboard/EventPartnerDashboard"
import DashboardFallback from "./dashboard/DashboardFallback"
import DashboardMain from "./dashboard/DashboardMain"
import DashboardMedia from "./dashboard/DashboardMedia"
import DashboardNabila from "./dashboard/DashboardNabila"
import DashboardSales from "./dashboard/DashboardSales"
import DashboardEventManager from "./dashboard/DashboardEventManager"
import styles from "./Dashboard.module.css"
import FailedJobsBanner from "../components/FailedJobsBanner"
import { canAccessPage } from "../common/permissions"

const Dashboard = () => {
    const context = useContext(MainContext)
    const user = context?.user

    if (!user) {
        return null
    }

    if (user?.company?.type === 'event_partner') {
        return <EventPartnerDashboard user={user} />
    }

    if (user?.company?.type) {
        return <CompanyDashboard user={user} />
    }

    const roleDashboards = {
        [AdminRole.Main]: DashboardMain,
        [AdminRole.Sales]: DashboardSales,
        [AdminRole.Media]: DashboardMedia,
        [AdminRole.Nabila]: DashboardNabila,
        [AdminRole.Marketing]: MarketingReports,
        [AdminRole.EventManager]: DashboardEventManager,
    }

    const RoleDashboard = roleDashboards[user.role] ?? DashboardFallback
    const jobsBanner = canAccessPage(user, 'jobs') ? <FailedJobsBanner key={user.id} /> : null

    if (user.role === AdminRole.Marketing) {
        return <RoleDashboard topContent={jobsBanner} />
    }

    return (
        <HeaderFooterLayout>
            <HelmetProvider>
                <Helmet>
                    <title>Dashboard</title>
                </Helmet>
            </HelmetProvider>
            <div className={styles.container}>
                {jobsBanner}
                <RoleDashboard user={user} />
            </div>
        </HeaderFooterLayout>
    )
}

export default Dashboard
